import styled from 'styled-components'
import { cores } from '../../styles'

import { CardPlaceholder as Card } from '../../components/LoadingCard/styles'

export const VagasContainer = styled.div`
  color: #fff;
  text-align: center;
  margin-top: 24px;

  .sectionTitle {
    margin-bottom: 36px;
  }
`

export const CardVaga = styled.div`
  margin-top: 24px;
`

export const CardPlaceholder = styled(Card)`
  height: 80px;
  background-color: rgba(255, 255, 255, 0.3);
`
